// @ts-nocheck
import { Fragment, FunctionalComponent, h } from "preact";
import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import * as ROUTES from "./resources/routes-name";
import LayoutSidebar from "./components/menu/layout/side-bar";
import { useAuthEffect } from "./hooks/useAuth";
import store from "./redux/store";
import RootRoute from "./routes/root-route";
import GlobalStyle from "./style/global-style";
import { navigationRef } from "./utils/navigation/navigation-services";
import { getAuthToken } from "./utils/storage/storage";
import HandleScene from "./screens/handle";
import WrapperComponent from "./components/hoc/WrapperComponent";

const AppContainer = () => {
  useAuthEffect();
  return (
    <>
      <Router ref={navigationRef}>
        {getAuthToken() && (
          <LayoutSidebar collapsed={false} onCollapse={(c) => console.log(c)} />
        )}
        <div />
        <Switch>
          <Route exact path={ROUTES.ROUTE_HANDLE} component={HandleScene} />
          <Route exact component={RootRoute} />
        </Switch>
      </Router>
    </>
  );
};

const App: FunctionalComponent = () => {
  return (
    <Provider store={store}>
      <AppContainer />
      <GlobalStyle />
    </Provider>
  );
};

export default WrapperComponent("App")(App);
